import type { Candidate } from "@/lib/applicant";

const TOKEN_KEY = "mmmocl_candidate_token";
const CANDIDATE_KEY = "mmmocl_candidate";

export function setCandidateSession(token: string, candidate: Candidate) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(CANDIDATE_KEY, JSON.stringify(candidate));
}

export function getCandidateToken(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(TOKEN_KEY);
}

export function getStoredCandidate(): Candidate | null {
  if (typeof window === "undefined") return null;
  const raw = localStorage.getItem(CANDIDATE_KEY);
  return raw ? (JSON.parse(raw) as Candidate) : null;
}

export function clearCandidateSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(CANDIDATE_KEY);
}
